exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /Users/yuki/Dropbox/Mac/Desktop/web design/dog-ema-wp/wp-content/themes/ema/node_modules/core-js/modules/_object-gops.js
// module id = 56
// module chunks = 0